module.exports = __webpack_public_path__ + "img/down.e5db95d8.svg";